export const initialValuesBankAccount = {
  currencycode: "",
  iban_number: "",
  bank_name: "",
  bank_address: "",
  bank_code: "",
};
